<template>
  <div class="register-page" ref="pageRef">
    <template v-if="!successShow">
      <div class="container">
        <img class="banner-img" :src="registerBanner" />

        <div class="form-content">
          <div class="form-li">
            <input
              class="input-item"
              v-model="phone"
              maxlength="11"
              type="number"
              placeholder="输入手机号码"
              @input="inputHandle('phone')"
              @blur="blurHandle()"
            />
          </div>
          <div class="form-li code-li">
            <input
              class="input-item"
              v-model="code"
              maxlength="6"
              type="number"
              placeholder="输入验证码"
              @input="inputHandle('code')"
            />
            <div class="code-btn" v-show="num === 0" @click="getCodeHandle">
              <span>获取验证码</span>
            </div>
            <div class="code-btn is-reciprocal" v-show="num > 0">{{ num }}s后重试</div>
          </div>
          <div class="error-tip" v-show="currentErrMsg">{{ currentErrMsg }}</div>
          <div class="submit-content">
            <button class="submit-btn" @click="submitHandle">注册免费体验</button>
          </div>
          <div class="footer-tip" @click="argee = !argee">
            <span class="radio-content" :class="argee ? 'is-argee' : ''"></span>
            <span>注册即同意</span>
            <span class="blue-text" @click.stop="showTipHandle('register')">《注册协议》</span>
            <span>和</span>
            <span class="blue-text" @click.stop="showTipHandle('privacy')">《隐私政策》</span>
          </div>
        </div>

        <h3 class="desc-title">
          <span>专为法学实证研究的法律大数据分析平台</span>
        </h3>

        <div class="video-content">
          <img class="video-mask-img" :src="descMask" />
          <video
            class="video-el"
            ref="videoRef"
            controls
            src="http://www.xiaobaogong.com/audio/实证分析首页视频.mp4"
            v-if="videoPlay"
          ></video>
          <template v-else>
            <img class="play-btn" :src="playBtn" @click="videoPlay = true" />
            <div class="video-mask" @click="videoPlay = true"></div>
            <div class="video-text">
              <div>法律实证分析平台</div>
              <div>重磅推荐</div>
            </div>
            <img class="video-bg-img" :src="videoBgImg" />
          </template>
        </div>

        <div class="introduction-ul">
          <div class="introduction-item">
            <img class="introduction-bg-img" :src="analysisBgImg" />
            <div class="introduction-item-content">
              <img class="icon-img" :src="analysisIcon1" />
              <div class="introduction-title">提供亿级全量大数据</div>
              <ul class="introduction-tip-ul">
                <li class="introduction-tip-li">提供亿级司法大数据库；</li>
                <li class="introduction-tip-li">对文书数据进行清洗、核对与校验；</li>
                <li class="introduction-tip-li">数据在线随时可用,实时自动更新；</li>
                <li class="introduction-tip-li">灵活接入用户自有数据。</li>
              </ul>
            </div>
          </div>
          <div class="introduction-item">
            <div class="introduction-item-content">
              <img class="icon-img" :src="analysisIcon2" />
              <div class="introduction-title">首创提供智能、精准、便捷、稳定的标注工具</div>
              <ul class="introduction-tip-ul">
                <li class="introduction-tip-li">国内首创以亿级裁判文书为核心的大规模预训练模型；</li>
                <li class="introduction-tip-li">提供为实证分析设计的预设数据维度体系；</li>
                <li class="introduction-tip-li">支持用户自定义数据维度,生成多样化、个性化维度体系；</li>
                <li class="introduction-tip-li">支持关键词智能推荐数据维度；</li>
                <li class="introduction-tip-li">多人协作,共享进度。</li>
              </ul>
            </div>
          </div>
          <div class="introduction-item">
            <img class="introduction-bg-img" :src="analysisBgImg2" />
            <div class="introduction-item-content">
              <img class="icon-img" :src="analysisIcon3" />
              <div class="introduction-title">提供轻松的数据清洗流程</div>
              <ul class="introduction-tip-ul">
                <li class="introduction-tip-li">构建“大数据+司法文书规则+先进算法”的智能模型；</li>
                <li class="introduction-tip-li">应用命名识别与实体消歧、关系抽取的关键技术；</li>
                <li class="introduction-tip-li">支持多人多事,复杂案件的人、事、罪名、情节抽取一一对应；</li>
                <li class="introduction-tip-li">快速、便捷的完成数据清洗过程。</li>
              </ul>
            </div>
          </div>
          <div class="introduction-item">
            <div class="introduction-item-content">
              <img class="icon-img" :src="analysisIcon4" />
              <div class="introduction-title">提供便捷的数据验证工具</div>
              <ul class="introduction-tip-ul">
                <li class="introduction-tip-li">存储用户实证分析的数据、维度、模型和结果,支持数据校验保证质量；</li>
                <li class="introduction-tip-li">支持自动验证和人工验证；</li>
                <li class="introduction-tip-li">快速追溯数据, 一键校验,让您的数据有据可查。</li>
              </ul>
            </div>
          </div>
          <div class="introduction-item">
            <img class="introduction-bg-img" :src="analysisBgImg" />
            <div class="introduction-item-content">
              <img class="icon-img" :src="analysisIcon5" />
              <div class="introduction-title">提供灵活的数据建模</div>
              <ul class="introduction-tip-ul">
                <li class="introduction-tip-li">一键快速生成简单统计分析数据模型；</li>
                <li class="introduction-tip-li">支持多种高级数据分析模型。</li>
              </ul>
              <div class="introduction-tip-desc">
                <div class="desc-item">聚类分析</div>
                <div class="desc-item">判别分析</div>
                <div class="desc-item">趋势预测</div>
                <div class="desc-item">逻辑回归</div>
                <div class="desc-item">关联分析</div>
                <div class="desc-item">描述性统计</div>
                <div class="desc-item">双重差分法</div>
                <div class="desc-item">三重差分法</div>
                <div class="desc-item">一元线性回归</div>
                <div class="desc-item">多元线性回归</div>
                <div class="desc-item">灰色预测模型</div>
                <div class="desc-item">时间序列模型</div>
              </div>
            </div>
          </div>
          <div class="introduction-item">
            <div class="introduction-item-content">
              <img class="icon-img" :src="analysisIcon6" />
              <div class="introduction-title">提供丰富多样的可视化数据图表</div>
              <ul class="introduction-tip-ul">
                <li class="introduction-tip-li">根据数据模型自动生成可视化图表；</li>
                <li class="introduction-tip-li">实时解释图表各值的含义；</li>
                <li class="introduction-tip-li">具有实证研究行业内领先的可视化图表库,充分满足不同的研究需求；</li>
                <li class="introduction-tip-li">支持图表下载；</li>
                <li class="introduction-tip-li">一键下载课题报告。</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="footer-btn-content" @click="scrollTopHandle">
          <span>注册免费体验</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="success-pane">
        <div class="success-img">
          <img :src="successImg" />
        </div>
        <div class="bottom-mask"></div>
        <div class="success-text">
          <span v-if="isRegister">您已注册成功</span>
          <span v-else>注册成功</span>
        </div>
        <div class="tip-text tip-text1">请使用电脑浏览器登录小包公官网试用</div>
        <div class="tip-text tip-text2">(www.xiaobaogong.com)</div>
        <div class="tip-text tip-text3">立即开始免费体验您的法律大数据分析！</div>
      </div>
    </template>

    <tip-modal :show.sync="tipModal.show" :mode="tipModal.mode" />
  </div>
</template>

<script>
import tipModal from '@/components/registerComponents/tipModal';

import successImg from '@/assets/img/successImg.png';
import registerBanner from '@/assets/img/register/registerBanner.png';
import videoBgImg from '@/assets/img/register/videoBgImg.png';
import analysisIcon1 from '@/assets/img/register/analysisIcon1.png';
import analysisIcon2 from '@/assets/img/register/analysisIcon2.png';
import analysisIcon3 from '@/assets/img/register/analysisIcon3.png';
import analysisIcon4 from '@/assets/img/register/analysisIcon4.png';
import analysisIcon5 from '@/assets/img/register/analysisIcon5.png';
import analysisIcon6 from '@/assets/img/register/analysisIcon6.png';
import analysisBgImg from '@/assets/img/register/analysisBgImg.png';
import analysisBgImg2 from '@/assets/img/register/analysisBgImg2.png';
import descMask from '@/assets/img/register/descMask.png';
import playBtn from '@/assets/img/register/playBtn.png';
import { services } from '@/service';

let timeController = 0;
let currentFontSize = '';

export default {
  components: { tipModal },
  data() {
    return {
      registerBanner,
      videoBgImg,
      playBtn,
      successImg,
      analysisIcon1,
      analysisIcon2,
      analysisIcon3,
      analysisIcon4,
      analysisIcon5,
      analysisIcon6,
      analysisBgImg,
      analysisBgImg2,
      descMask,
      argee: true,
      phone: '',
      code: '',
      num: 0,
      isFetch: false,
      errMsg: {
        phone: '',
        code: ''
      },
      loading: false,
      codeLoading: false,
      successShow: false,
      isRegister: false,
      videoPlay: false,
      tipModal: {
        show: false,
        mode: ''
      }
    };
  },
  computed: {
    currentErrMsg() {
      let msg = '';
      Object.keys(this.errMsg).forEach(key => {
        if (this.errMsg[key]) {
          msg = this.errMsg[key];
        }
      });
      return msg;
    }
  },
  watch: {
    async videoPlay(val) {
      if (!val) {
        return;
      }
      await this.$nextTick();
      this.$refs.videoRef.play();
    }
  },
  created() {
    this.isRegister = !!localStorage.getItem('is_register');
    if (this.isRegister) {
      this.successShow = true;
    }
  },
  mounted() {
    const body = document.getElementsByTagName('html')[0];
    currentFontSize = body.style.fontSize;
    this.resizeFontSize();
    window.addEventListener('resize', this.resizeFontSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeFontSize);
  },
  destroyed() {
    this.setBodyFontSize(currentFontSize);
  },
  methods: {
    showTipHandle(mode) {
      this.tipModal = { show: true, mode };
    },
    scrollTopHandle() {
      this.$refs.pageRef.scrollTop = 0;
    },
    resizeFontSize() {
      const docWidth = document.documentElement.clientWidth;
      this.setBodyFontSize(docWidth / 37.5 + 'px');
    },
    setBodyFontSize(val) {
      const body = document.getElementsByTagName('html')[0];
      body.style.fontSize = val;
    },
    blurHandle() {
      if (this.phone.length !== 11) {
        this.errMsg.phone = '请输入正确手机号码';
      } else {
        this.errMsg.phone = '';
      }
    },
    inputHandle(type) {
      if (type === 'phone') {
        this.phone = this.phone.slice(0, 11);
      }
      if (type === 'code') {
        this.code = this.code.slice(0, 6);
      }
    },
    async getCodeHandle() {
      if (!this.phone) {
        this.errMsg.phone = '请输入正确手机号码';
        return;
      }
      if (this.errMsg.phone) {
        return;
      }
      if (this.codeLoading) {
        return;
      }
      try {
        this.codeLoading = true;
        await services.authriozation.getSmsCode({ tel: this.phone });
        this.isFetch = true;
        this.timeoutHandle();
      } catch (err) {
        this.errMsg.code = err.message;
      } finally {
        this.codeLoading = false;
      }
    },
    async submitHandle() {
      if (!this.argee) {
        this.errMsg.phone = '请勾选同意隐私政策';
        return;
      }
      if (!this.phone) {
        this.errMsg.phone = '请输入正确手机号码';
        return;
      }
      if (!this.code) {
        this.errMsg.code = '请输入验证码';
        return;
      }
      if (!this.isFetch) {
        this.errMsg.code = '请获取验证码';
        return;
      }
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const regUrl = window.location.href;
        await services.authriozation.setValid({ tel: this.phone, code: this.code, regUrl });
        this.successShow = true;
        localStorage.setItem('is_register', 1);
      } catch (err) {
        this.errMsg.code = err.message;
      } finally {
        this.loading = false;
      }
    },
    timeoutHandle() {
      this.num = 60;
      timeController = setInterval(() => {
        this.num--;
        if (this.num === 0) {
          clearInterval(timeController);
          timeController = 0;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: none;
}

input {
  -webkit-appearance: none;
}

@function rem($px) {
  @return $px * 0.1rem;
}

.success-pane {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f8fafd;

  .success-img {
    width: rem(60);
    height: rem(60);
    font-size: 0;
    margin: rem(100) auto rem(10);

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  .bottom-mask {
    width: rem(36);
    height: rem(4);
    border-radius: 50%;
    background-color: #d9dde4;
    margin: 0 auto;
  }

  .success-text {
    color: #222222;
    font-size: rem(18);
    line-height: rem(28);
    text-align: center;
    margin-top: rem(10);
    font-weight: 300;
  }

  .tip-text {
    font-size: rem(16);
    color: #3d465a;
    text-align: center;
    font-weight: 300;
    &.tip-text1 {
      margin-top: rem(40);
    }
    &.tip-text2 {
      margin-top: rem(6);
    }
    &.tip-text3 {
      margin-top: rem(12);
    }
  }
}
.register-page {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .container {
    position: relative;
    padding: rem(346) rem(20) rem(30);
    background-color: #fff;

    .banner-img {
      position: absolute;
      top: rem(-10);
      left: rem(-10);
      width: calc(100% + #{rem(20)});
      z-index: 1;
    }

    .form-content {
      box-sizing: border-box;
      position: relative;
      padding: rem(27);
      border-radius: rem(9);
      box-shadow: rem(0) rem(3) rem(16) rem(3) rgba(0, 0, 0, 0.1);
      background-color: #fff;
      z-index: 2;

      .error-tip {
        font-size: rem(14);
        color: #e42626;
        height: rem(20);
        line-height: rem(20);
        margin-top: rem(10);
      }

      .submit-content {
        margin-top: rem(20);

        .submit-btn {
          width: 100%;
          color: #fff;
          font-size: rem(14);
          line-height: rem(43);
          border-radius: rem(22);
          background-color: #0683fb;
          border: 0;
          cursor: pointer;
          box-shadow: 0 rem(6) rem(16) rem(4) rgba(48, 52, 58, 0.1);
        }
      }

      .footer-tip {
        width: 100%;
        text-align: center;
        color: #77839e;
        font-size: rem(14);
        line-height: rem(20);
        z-index: 10;
        background-color: #fff;
        margin-top: rem(20);

        .blue-text {
          color: #0c93f2;
        }

        .radio-content {
          box-sizing: border-box;
          display: inline-block;
          position: relative;
          top: rem(2);
          width: rem(14);
          height: rem(14);
          border: rem(1) solid #a0acc0;
          margin-right: rem(4);
          border-radius: 50%;
          overflow: hidden;
          transform: scale(0.9);
          background-color: #fff;

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: rem(4);
            height: rem(4);
            background-color: #fff;
            border-radius: 50%;
          }

          &::before {
            content: '';
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: #0c93f2;
            border-radius: 50%;
          }

          &.is-argee {
            border: 0;
            &::before {
              display: block;
            }
          }
        }
      }

      .form-li {
        display: flex;
        margin-top: rem(20);

        &:first-child {
          margin-top: 0;
        }

        .input-item {
          box-sizing: border-box;
          flex: 1;
          width: 0;
          padding: rem(10) rem(12);
          font-size: rem(14);
          border-radius: rem(2);
          border: rem(1) solid rgba(#a0acc0, 0.8);
          color: rgba(#2c3443, 0.8);

          &::-webkit-input-placeholder {
            color: rgba(#a8b2c3, 0.6);
          }
        }

        .code-btn {
          box-sizing: border-box;
          width: rem(87);
          height: rem(44);
          font-size: rem(14);
          line-height: rem(44);
          color: #0683fb;
          text-align: center;
          cursor: pointer;
          border: rem(1) solid rgba(#a0acc0, 0.8);
          border-radius: rem(2);

          &.is-reciprocal {
            color: rgba(#a8b2c3, 0.6);
          }
        }

        &.code-li {
          .input-item {
            border-right: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          .code-btn {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }

    .desc-title {
      position: relative;
      font-size: rem(28);
      line-height: rem(39);
      padding-right: rem(20);
      margin: rem(50) 0 rem(27);
      color: #2c3443;
      z-index: 2;

      & > span {
        font-weight: 600;
      }
    }

    .video-content {
      position: relative;
      width: 100%;
      height: rem(190);
      border-radius: rem(6);
      overflow: hidden;

      .video-mask-img {
        position: absolute;
        left: rem(-20);
        bottom: rem(70);
        width: calc(100% + #{rem(40)});
        z-index: 1;
      }

      .video-el {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 2;
      }

      .play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: rem(54);
        height: rem(54);
        z-index: 5;
      }

      .video-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0.2);
        z-index: 4;
      }

      .video-text {
        position: absolute;
        top: rem(72);
        left: rem(25);
        color: #001529;
        font-size: rem(16);
        line-height: rem(23);
        z-index: 3;

        & > div {
          font-weight: 450;
        }
      }

      .video-bg-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    }

    .introduction-ul {
      margin-top: rem(50);
      .introduction-item {
        position: relative;

        margin-top: rem(27);

        .introduction-bg-img {
          position: absolute;
          top: 0;
          left: rem(-20);
          width: calc(100% + #{rem(40)});
          z-index: 1;
        }

        .introduction-item-content {
          position: relative;
          box-sizing: border-box;
          width: 100%;
          background-color: #fff;
          box-shadow: 0 rem(4) rem(19) 0 rgba(0, 0, 0, 0.05);
          border-radius: rem(4);
          padding: rem(23) rem(18);
          z-index: 2;
          .icon-img {
            width: rem(50);
            height: rem(50);
          }

          .introduction-title {
            color: #001529;
            font-size: rem(20);
            line-height: rem(28);
            margin-top: rem(20);
            font-weight: 600;
          }

          .introduction-tip-ul {
            color: #3d465a;
            font-size: rem(14);
            line-height: rem(22);

            .introduction-tip-li {
              list-style: disc;
              margin-left: rem(20);
              margin-top: rem(10);
            }
          }

          .introduction-tip-desc {
            display: flex;
            flex-wrap: wrap;
            margin-top: rem(15);

            .desc-item {
              box-sizing: border-box;
              position: relative;
              width: 33.33%;
              padding-left: rem(20);
              font-size: rem(9);
              line-height: rem(23);
              color: #3d465a;
              margin-top: rem(4);

              &::after {
                box-sizing: content-box;
                content: '';
                border: rem(1) solid #1991fb;
                border-left: 0;
                border-top: 0;
                width: rem(4);
                height: rem(10);
                position: absolute;
                left: rem(5);
                top: rem(4);
                transform: rotate(45deg) scaleY(1);
                transform-origin: center;
              }
            }
          }
        }
      }
    }

    .footer-btn-content {
      color: #fff;
      line-height: rem(43);
      font-size: rem(14);
      text-align: center;
      box-shadow: 0 rem(3) rem(7) rem(2) rgba(48, 52, 58, 0.04);
      background-color: #0683fb;
      border-radius: rem(22);
      margin: rem(36) 0 rem(10);
    }
  }
}
</style>
